module.exports = __webpack_public_path__ + "static/media/place_bets.99d0b124.mp3";